// extracted by mini-css-extract-plugin
export default {"button":"Button_button__ufG7+","light":"Button_light__cn1Rr","back":"Button_back__F8jRx","green":"Button_green__stkO6","light1":"Button_light1__FYw8L"};